import { IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const IngestSiteModal = ({ orgData, buttonComponent }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => { setShow(false) };
    const handleShow = () => setShow(true);

    async function ingest() {
        loadingShow();
        let postData = {
            "organizationId": orgData?.orgId,
            "url": document.getElementById('website')?.value
        }
        let resp = await postApi(postData, urlApi.ingestSite);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <>
            <div onClick={handleShow} className='w-max'>{buttonComponent}</div>

            <Modal show={show} onHide={handleClose} backdrop="static" >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Ingest Website to this Organization</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className='flex flex-col gap-2'>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="website" className='font-medium'>Website URL</label>
                            <input type="text" id='website' placeholder="https://abc.com" className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' />
                        </div>
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='px-4 py-1 bg-[var(--secondary)] text-white text-sm font-semibold rounded-lg' onClick={handleClose}>Cancel</button>
                        <button className='px-4 py-1 bg-[var(--secondary-gradient-1)] text-white text-sm font-semibold rounded-lg' onClick={() => ingest()}>Ingest</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default IngestSiteModal